import {
    baseRoutes,
    adminRoutes,
} from './routes';
import Landing from '../../Landing/Landing';
import AppNameListPage from '../../AppName/List';
import AppNameCreatePage from '../../AppName/Create';
import AppNameEditPage from '../../AppName/Edit';

export const rolesConfig = {
    default: [{
        route: baseRoutes.landing,
        component: Landing,
        name: 'Main Page',
    }],
    admin: [{
        route: adminRoutes.appNameListPage,
        component: AppNameListPage,
        name: 'App profiles',
    }, {
        route: adminRoutes.appNameCreatePage,
        component: AppNameCreatePage,
        name: 'Add App profile',
    }, {
        route: adminRoutes.appNameEditPage,
        component: AppNameEditPage,
        name: 'Edit App profile',
    }],
};
